@if (canEditRoute) {
  <div [matTooltip]="deleteButtonTooltip" class="configuration-route-view__delete-button">
    <xi-icon-button
      color="CX"
      icon="trash"
      buttonSize="large"
      [disabled]="!!(isLoading || isSaving || hasAutoAnalysis || hasOngoingAnalysis)"
      (onClick)="onDeleteRoute()"
    >
    </xi-icon-button>
  </div>
}
@if (isLoading) {
  <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}
@if (selectedRoute) {
  <div>
    <xi-horizontal-tab-bar
      [data]="configRouteTabs"
      [activeTabId]="activeTab"
      [hasTransparentBackground]="true"
      color="CX"
      (onTabChange)="interceptTabChange($event.detail.tab.id)"
    ></xi-horizontal-tab-bar>
    <div class="config-route-view__tab-keyline"></div>
    <div
      [ngClass]="
        activeTab === 'configurations'
          ? 'config-route-view__tab--visible'
          : 'config-route-view__tab--hidden'
      "
    >
      <app-configuration-route-configurations
        [configurationRoute]="selectedRoute"
        [configurations]="configurations"
        [canEditRoute]="canEditRoute"
      ></app-configuration-route-configurations>
    </div>
    <div
      [ngClass]="
        activeTab === 'settings'
          ? 'config-route-view__tab--visible'
          : 'config-route-view__tab--hidden'
      "
    >
      <app-configuration-route-edit
        #configRouteEditTab
        [configurationRoute]="selectedRoute"
        [hasAutoAnalysis]="hasAutoAnalysis"
        [canEditRoute]="canEditRoute"
      ></app-configuration-route-edit>
    </div>
  </div>
}
